var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreCsBRm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 24L22 4C22 2.89543 21.1046 2 20 2L4 2C2.89543 2 2 2.89543 2 4L2 24C2 25.1046 2.89543 26 4 26L20 26C21.1046 26 22 25.1046 22 24ZM24 4C24 1.79086 22.2091 0 20 0L4 0C1.79086 0 0 1.79086 0 4L0 24C0 26.2091 1.79086 28 4 28L20 28C22.2091 28 24 26.2091 24 24L24 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2351 1.2019H18.2351V5.9997H22.6116V7.9997H16.2351V1.2019Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24399 4.41883C7.98157 4.37991 7.71443 4.44686 7.50139 4.60494L4.11918 7.11463C3.6758 7.44363 3.58294 8.06971 3.91174 8.51323L12.8349 20.5499C12.9127 20.6547 13.0102 20.7433 13.122 20.8107L17.8639 23.6697C18.2111 23.879 18.6503 23.858 18.976 23.6165C19.3016 23.375 19.4492 22.9608 19.3496 22.5678L17.9899 17.1991C17.9579 17.0727 17.9015 16.9538 17.8238 16.8491L8.90061 4.81247C8.74262 4.59935 8.50641 4.45775 8.24399 4.41883ZM16.0996 17.8816L16.8137 20.7011L14.3239 19.2L6.11367 8.12513L7.88975 6.80723L16.0996 17.8816Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.091 7.87034C9.77763 7.41554 9.15494 7.30086 8.70014 7.6142L6.43256 9.17645C5.97777 9.48979 5.86309 10.1125 6.17642 10.5673C6.48976 11.0221 7.11245 11.1368 7.56725 10.8234L9.83482 9.26116C10.2896 8.94783 10.4043 8.32513 10.091 7.87034Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7748 15.8679C16.4257 15.4399 15.7958 15.3759 15.3678 15.725L12.3678 18.1721C11.9398 18.5212 11.8758 19.1511 12.2249 19.5791C12.574 20.007 13.2039 20.071 13.6319 19.7219L16.632 17.2748C17.0599 16.9258 17.1239 16.2958 16.7748 15.8679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreCsBRm);
export default __webpack_public_path__ + "static/media/breCsBRm.d8eaab9306dbc93883dd07f1d05db817.svg";
export { ForwardRef as ReactComponent };